// WHAT CAN BE CHANGED?
// Put the desired links into the links-array under data()
// Make sure to enter the name, icon and route correctly
// You can also make style changes accordingly
// Remember to change the colour of the hamburger icon

<template>
  <div id="top-header">
    <svg-icon
    @click="openMenu"
      icon="hamburger"
      fill="#F55000"
      height="20px"
      width="22px"
      id="top-header__icon-left"
    />
    <img id="top-header__logo" src="@/assets/company-logo.png" v-on:click="goto('/')"/>
  </div>
  <!-- The Side Menu -->
    <div id="top-header__overlay" @click="closeMenu"/>
    <div id="top-header__sideMenu">
      <img :src="require(`@/assets/topheader/bg-sidemenu-narrow.png`)"/>
      <svg-icon 
        @click="closeMenu"
        icon="close"
        fill="#FFFFFF"
        height="20px"
        width="20px"
        id="top-header__sideMenu__close"
      />
      <div v-for="link in links" v-on:click="goto(link.router)" v-bind:key="link.name" class="top-header__sideMenu__links">
          <svg-icon class="top-header__sideMenu__links__icon" v-bind:icon="link.icon" height="18px" width="18px" /> {{ link.name }}
      </div>
      <button v-on:click="installPWA()" id="top-header__sideMenu__install-button" v-if="androidNotInstalled">Installeer</button>
      <div id="top-header__sideMenu__technical">
          <p>RTV Parkstad App <span>-</span> Versie 1.0</p>
          <div id="top-header__sideMenu__technical__powered">
            <h2>Powered by TAPPIR</h2>
            <img src="@/assets/tappir-logo.svg"/>
          </div>
      </div>
  </div>
  
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
export default {
  name: "TopHeader",
  components: {
    SvgIcon,
  },
  props: {
    logo: String,
  },
  mounted() {
    document.getElementById("app").addEventListener("touchstart", this.startTouch, false);
    document.getElementById("app").addEventListener("touchmove", this.moveTouch, false);
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event in deferredPrompt to trigger the browser install prompt later.
      this.deferredPrompt = e;
      // Optionally, send analytics event that PWA install promo was shown.
      console.log(`'beforeinstallprompt' event was fired.`);
    });
    if(this.isAndroid() && this.getPWADisplayMode() == "browser") {
      this.androidNotInstalled = true;
    }
  },
  methods: {
      startTouch(e) {
        this.initialX = e.touches[0].clientX;
        this.initialY = e.touches[0].clientY;
      },
      moveTouch(e) {
        if (this.initialX === null) {
          return;
        }
        if (this.initialY === null) {
          return;
        }
        let currentX = e.touches[0].clientX;
        let currentY = e.touches[0].clientY;
      
        let differenceX = this.initialX - currentX;
        let differenceY = this.initialY - currentY;

        if (Math.abs(differenceX) > Math.abs(differenceY)) {
          // sliding horizontally
          if (differenceX > 0) {
            // swiped left
            this.closeMenu();
          } else {
            // swiped right
            this.openMenu();
          }  
        } else {
          // sliding vertically
          if (differenceY > 0) {
            // swiped up
          } else {
            // swiped down
          }  
        }
      
        this.initialX = null;
        this.initialY = null;
      },
      openMenu() {
          document.getElementById("top-header__sideMenu").style.marginLeft = "0";
          document.getElementById("top-header__overlay").style.opacity = "0.7";
          document.getElementById("top-header__overlay").style.pointerEvents = "auto";
      },
      closeMenu() {
          document.getElementById("top-header__sideMenu").style.marginLeft = "-290px";
          document.getElementById("top-header__overlay").style.opacity = "0";
          document.getElementById("top-header__overlay").style.pointerEvents = "none";
      },
      goto(route) {
        this.closeMenu()
        this.$router.push(route)
      },
      async installPWA() {
        // Op localhost werkt dit onderste niet, maar op de server wel
        this.deferredPrompt.prompt();
        this.deferredPrompt = null;
      },
      isAndroid() {
        let userAgent = navigator.userAgent.toLowerCase()
          if (userAgent.indexOf("android") > -1) {
            return true;
          } else {
            return false;
        }
      },
      getPWADisplayMode() {
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
        if (document.referrer.startsWith('android-app://')) {
          return 'twa';
        } else if (navigator.standalone || isStandalone) {
          return 'standalone';
        }
          return 'browser';
      },
  },
  data() {
        return {
            links: [
                { name: "Home", icon: "home", router: "/" },
                { name: "Luister", icon: "listen", router: "/listen" },
                // { name: "Bericht", icon: "message", router: "/bericht" },
                { name: "Bericht", icon: "message", router: "/message" },
                { name: "Kijk", icon: "watch", router: "/watch" },
                { name: "Gemist", icon: "missed", router: "/missed" },
                { name: "Word vrijwilliger!", icon: "briefcase", router: "/vrijwilliger" },
                { name: "Adverteren", icon: "tag", router: "/adverteren" },
                { name: "Contact", icon: "envelope", router: "/contact" }
            ],
            initialX: null,
            initialY: null,
            deferredPrompt: null,
            androidNotInstalled: null
        };
    }
};
</script>

<style lang="scss" scoped>
$sideMenu__icon--colour: #FF6600;
$sideMenu__background--colour: #ffffff;
$sideMenu__background--colour-selected: #E0E0E0;
$sideMenu__text--font: "Lato";

#top-header {
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100%;
  background-color: white;
  box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.2);
  height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;

  #top-header__logo {
    height: 40px;
  }

  #top-header__icon-left {
    position: absolute;
    left: 16px;
    display: flex;
    align-items: center;
  }

  #top-header__version {
    position: absolute;
    right: 16px;
    font-family: $sideMenu__text--font;
    font-size: 18px;
  }
}

#top-header__overlay {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: black;
  z-index: 1000;
  opacity: 0;
  pointer-events:none;
  transition: 0.3s;
}

#top-header__sideMenu {
    margin-left: -290px;
    height: 100%;
    width: 290px;
    position: fixed;
    top: 0;
    left: 0;
    background-color: $sideMenu__background--colour;
    transition: 0.3s;
    z-index: 1001;
    font-family: $sideMenu__text--font;
    font-weight: bold;
    font-size: 14px;
    

    img {
      margin-bottom: -4px;
      width: 290px;
      height: 130px;
    }

    #top-header__sideMenu__close {
      position: absolute;
      top: 18px;
      right: 18px;
    }

    .top-header__sideMenu__links {
      margin-top: -2px;
      display: grid;
      grid-template-columns: 70px 1fr;
      align-items: center;
      background-color: $sideMenu__background--colour;
      width: 100%;
      height: 48px;
      text-decoration: none;
      color:$sideMenu__icon--colour;

      .top-header__sideMenu__links__icon {
        margin-left: 25px;
        fill: $sideMenu__icon--colour;
      }
    }
    .router-link-exact-active {
        background-color: $sideMenu__background--colour-selected;
    }

    #top-header__sideMenu__install-button {
      font-size: 20px;
      color: white;
      font-weight: bold;
      width: 150px;
      height: 40px;
      border-radius: 999px;
      background-color: #F55000;
      border: none;
      margin-left: calc(50% - 75px);
      margin-top: 10px;
    }

    #top-header__sideMenu__technical {
      position: absolute;
      bottom: 0px;
      width: 290px;
      background-color: #F1F1F1;
      height: 65px;
      box-sizing: border-box;
      text-decoration: none;

      p {
        font-size: 11px;
        color: #888888;
        text-align: center;
        margin: 10px 0px 10px;
      }
      span {
        margin: 0px 6px;
      }

      #top-header__sideMenu__technical__powered{
        display: flex;
        align-items: center;
        justify-content: center;

        h2 {
          font-family: "Fira Sans";
          font-size: 14px;
          color: #3a3c39;
          margin-right: 10px;
        }
        img {
          height: 24px;
          display: inline;
          width: unset;
          margin-top: -4px;
        }
      }
    }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
  #top-header {
  }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
  #top-header {
  }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px) {
  #top-header {
  }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px) {
  #top-header {
    display: none;
  }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px) {
  #top-header {
    display: none;
  }
}
</style>